import fetcher from '@/data/utils/fetcher';
import { getUrlLocale } from '@/utils/url';

export const SearchService = {
  async getSearchResults(query) {
    return fetcher(`/api/searchresults/getsearchresults/?q=${query}&language=${getUrlLocale()}`);
  },
};
